import { Component } from '@angular/core';
import { AsyncPipe, NgClass } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SideNavComponent } from '../side-nav/side-nav.component';

// ngx-bootstrap
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

// ngx-scrollbar
import { NgScrollbarModule } from 'ngx-scrollbar';

// ngx-avatars
import { AvatarModule } from 'ngx-avatars';

@Component({
    selector: 'app-side-nav-mobile',
    standalone: true,
    imports: [
        AsyncPipe,
        NgClass,
        RouterModule,
        AccordionModule,
        TooltipModule,
        NgScrollbarModule,
        AvatarModule,
    ],
    templateUrl: './side-nav-mobile.component.html',
    styleUrls: ['./side-nav-mobile.component.scss'],
})
export class SideNavMobileComponent extends SideNavComponent {
    sideNavClose() {
        this.layoutService.toggleSidebarExpandedState(false);
    }
}
